import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';

import FlagGroup from '@atlaskit/flag/flag-group';

import SuccessIcon from '@atlaskit/icon/core/status-success';

import { token } from '@atlaskit/tokens';

import { type FunctionComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import { productNameByVariant } from './Body';

import { registeredContentByProduct } from './content';

import type { TargetProduct } from '../types';

type Props = {
	isVisible: boolean;
	targetProduct: TargetProduct;
	onDismiss: () => void;
};

/**
 * Shown after a REQUEST_ACCESS user successfully requests to join.
 *
 * FlagGroup is mounted for the lifetime of the message rather than alongside the flag, because
 * its ExitingPersistence uses `appear={false}` — a flag present on first mount skips the slide in.
 */
export const RequestSentFlag: FunctionComponent<Props> = ({
	isVisible,
	targetProduct,
	onDismiss,
}) => (
	<FlagGroup onDismissed={onDismiss}>
		{isVisible ? (
			<AutoDismissFlag
				id="cjn-nav4-request-sent-flag"
				icon={
					<SuccessIcon spacing="spacious" label="Success" color={token('color.icon.success')} />
				}
				title={
					<FormattedMessage
						{...registeredContentByProduct[targetProduct].default.requestSentFlagTitle}
					/>
				}
				description={
					<FormattedMessage
						{...registeredContentByProduct[targetProduct].default.requestSentFlagDescription}
						values={{ productName: productNameByVariant[targetProduct] }}
					/>
				}
				actions={[]}
			/>
		) : null}
	</FlagGroup>
);
